(function ($) {
  'use strict';

  //This is needed for Bootstrap 3.4.1+ as tables aren't included in their new sanitizer for tooltip and popover by default
  //https://getbootstrap.com/docs/3.4/javascript/#js-sanitizer
  function SetWhitelist() {
    if (typeof $.fn.tooltip.Constructor !== 'undefined') {
      var defaultWhiteListTooltip = $.fn.tooltip.Constructor.DEFAULTS.whiteList;

      //To allow table elements in tooltips
      defaultWhiteListTooltip.table = [];
      defaultWhiteListTooltip.thead = [];
      defaultWhiteListTooltip.tbody = [];
      defaultWhiteListTooltip.tfoot = [];
      defaultWhiteListTooltip.th = [];
      defaultWhiteListTooltip.tr = [];
      defaultWhiteListTooltip.td = [];
      defaultWhiteListTooltip.th = ['colspan'];
      defaultWhiteListTooltip.td = ['colspan'];
    }
    if (typeof $.fn.popover.Constructor !== 'undefined') {
      var defaultWhiteListPopover = $.fn.popover.Constructor.DEFAULTS.whiteList;

      //To allow table elements in popovers
      defaultWhiteListPopover.table = [];
      defaultWhiteListPopover.thead = [];
      defaultWhiteListPopover.tbody = [];
      defaultWhiteListPopover.tfoot = [];
      defaultWhiteListPopover.th = [];
      defaultWhiteListPopover.tr = [];
      defaultWhiteListPopover.td = [];
      defaultWhiteListPopover.th = ['colspan'];
      defaultWhiteListPopover.td = ['colspan'];
    }
  }

  SetWhitelist();
})(jQuery);